module.exports = __webpack_public_path__ + "static/media/directors-message-banner.762f7a07.png";